// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"12589":"7c0e93e3","38447":"6c4e8d7d","80300":"9a885429"}[chunkId] + ".css";
};